<template>
  <div class="notification-image" :class="{ 'notification-unread': !isRead }">
    <div class="avatar-img-wrap">
      <img v-if="showImage"
           class="avatar-img"
           :src="image"
           alt="notification-icon"
           @error="setShowImage"
      >
      <img v-else
           class="avatar-img"
           src="@/assets/images/icons/default_notification.svg"
           alt="notification-icon"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationImage",

  props: {
    image: {
      type: String,
      default: ''
    },
    isRead: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
      showImage: true
    }
  },

  methods: {
    setShowImage() {
      this.showImage = false
    }
  }
}
</script>

<style scoped lang="scss">
.notification {
  &-image {
    position: relative;
    margin-right: 20px;
    width: 100%;
    max-width: 48px;

    img {
      width: 100%;
      object-fit: cover;
      max-height: 48px;
      border-radius: 8px;
    }
  }
  &-unread {
    position: relative;
    &:before {
      content: "";
      width: 10px;
      height: 10px;
      position: absolute;
      left: -20px;
      top: 20px;
      background: #F0251E;
      border-radius: 50%;
    }
  }
}
</style>
